(function () {
  'use strict';

  console.group('[EdgeTag Debugger] URL Params');

  const params = new URLSearchParams(window.location.search);

  if (![...params.keys()].length) {
    console.log('No URL params found');
  } else {
    params.forEach((value, key) => {
      console.log(key + ':', value);
    });
  }

  console.groupEnd();

  console.group('[EdgeTag Debugger] Cookies');

  if (!document.cookie) {
    console.log('No cookies found');
  } else {
    document.cookie.split(';').forEach(cookie => {
      console.log(cookie.trim());
    });
  }

  console.groupEnd();

  console.group('[EdgeTag Debugger] Important Tracking Values');

  const important = [
    'tag_user_id',
    '_fbp',
    '_fbc',
    '_ga'
  ];

  important.forEach(name => {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name + '=([^;]*)')
    );

    const value = match
      ? decodeURIComponent(match[1])
      : null;

    console.log(name + ':', value || 'NOT FOUND');
  });

  console.groupEnd();

})();